import SchoolDetailsPage from "./schoolDetailsPage"

export default SchoolDetailsPage;